import { CASE_STUDIES } from "../data/portfolio";

const TrackRecordSection = () => (
  <section className="section-enter max-w-[1180px]">
    <div className="mb-2 flex items-baseline gap-4">
      <h2 className="font-heading text-[40px] font-medium tracking-[-0.02em]">
        Track record
      </h2>
      <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
        Five sectors, one line
      </span>
    </div>

    <p className="mb-7 max-w-[660px] text-[14.5px] text-neutral-500">
      The work behind the résumé line. Each card is a system I owned end to end —
      the constraint, the call I made, and what it changed.
    </p>

    <div className="grid grid-cols-3 gap-3.5">
      {CASE_STUDIES.map((c) => (
        <article key={c.num} className="card flex min-h-[340px] flex-col gap-3 p-[20px_18px]">
          <div className="flex items-center gap-2.5">
            <span className="h-0.5 w-4 bg-accent" />
            <span className="text-[10px] uppercase tracking-[0.2em] tabular-nums text-neutral-500">
              Sector {c.num}
            </span>
          </div>

          <h3 className="font-heading text-[19px] font-medium tracking-[-0.01em]">
            {c.domain}
          </h3>

          <p className="text-[13px] leading-[1.55] text-neutral-400">{c.problem}</p>

          <p className="border-l-2 border-accent-800 pl-2.5 text-[13px] leading-[1.6] text-neutral-500">
            {c.call}
          </p>
        </article>
      ))}
    </div>
  </section>
);

export default TrackRecordSection;
